<template>
  <Head :title="`${project.name}｜${gym.title}`" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="main project">

        <div class="c-header">
          <Link :href="`/gyms/${gym.slug}/${project.grade_id}`">
            <img src="/images/icons/icon-chevron-left.svg" alt="back" class="c-header__back">
          </Link>

          <div class="c-header--h2 split">
            <div class="c-header_left">
              <div class="c-header_title">{{ project.name }}</div>
              <div class="c-header_info">
                {{ category.name }} / 
                {{ wall.name }} / 
                {{ grade.title }}<br>
                WINNER {{ project.number_of_completed }}人
              </div>
              <div v-if="new Date(project.startdate) > new Date()" class="c-header_info red bold">
                公開前：{{ project.startdate }}に公開
              </div>
              <div v-else class="c-header_info">
                {{ project.startdate }}〜{{ project.enddate }}
              </div>
            </div>

            <!-- kawaii monsters -->
            <div v-if="$page.props.auth.user" class="c-header_cleared">
              <div v-if="project.status == 'flash'" class="pickupG_wrap_row_cleared_status single flash">
                <img src="/images/icons/icon-flash.svg">
              </div>
              <div v-else-if="project.status == 'rp'" class="pickupG_wrap_row_cleared_status single rp">
                <img src="/images/icons/icon-check.svg">
              </div>
              <div v-else class="pickupG_wrap_row_cleared_status single monster">
                <img :src="`/images/monster/${monsters[$page.props.auth.chara.level][project.id%3].name}.gif`">
              </div>
            </div>
            
          </div>

        </div>

        <p v-if="project.memo" class="pickupG_wrap_description">{{ project.memo }}</p>

        <div v-if="project.image" class="mt-24">
          <img :src="`${imgPath}${project.image}`">
        </div>
        <div v-else class="mt-24">
          <img src="/images/common/no-image.jpg">
        </div>

        <div v-if="!auth.user" class="c-button-wrap">
          <div class="c-button light-gray half inactivate">
            <span>イチゲキ</span>
          </div>
          <div class="c-button light-gray half inactivate">
            <span>完登</span>
          </div>
        </div>
        <div v-else-if="project.status != 'flash' && project.status != 'rp'" class="c-button-wrap">
          <Link :href="`/users/accomplish/${project.id}/flash`" class="c-button orange half"><img src="/images/icons/icon-flash.svg" class="icon">イチゲキ
          </Link >
          <Link :href="`/users/accomplish/${project.id}/rp`" class="c-button green half"><img src="/images/icons/icon-check.svg" class="icon">完登
          </Link >
        </div>
        <div v-else class="mt-24">
          <Link :href="`/users/accomplish/${project.id}/delete`" class="c-button gray">記録を取消
          </Link >
        </div>

        <!-- admin or 特定gym owner only -->
        <div class="admin-area" v-if="(auth.user && user.can.isAdmin) || (auth.user && user.can.isOwnerHigher && gym.users && gym.users.length > 0 && auth.user.id == gym.users[0].pivot.user_id)">
          <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
          <div class="c-button-wrap">
            <Link :href="`/projects/${project.id}/edit`" class="c-button half">編集</Link>
            <Link @click="destroy(project.id)" class="c-button half red">課題を削除
            </Link>
          </div>
        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    Inertia,
    Side,
  },

  // setup(props) {
  //   const form = useForm({
  //     name: props.project.name,
  //     image: props.project.image,
  //   });

  //   return { form };
  // },

  props: {
    project: Object,
    gym: Object,
    auth: Object,
    user: Object,
    category: Object,
    wall: Object,
    grade: Object,
    monsters: Object,
    imgPath: String,
    // uProjects: Object,
  },

  setup(props) {
    // const form = useForm({
    //   name: props.project.name,
    //   image: props.project.image,
    // });
    // return { form };
    // monsters = config('const.Monsters');
      // console.log(monsters)
  },
  methods: {
    destroy(id) {
        if (confirm('本当に削除しますか？')) {
            this.$inertia.delete(route("projects.destroy", id));
        }
    },
  },

//   methods: {
//     //status表示
//     showStatus(projectId) {
//       let status = "-";
// console.log(this.uProjects);
//       this.uProjects.forEach(function(uProject){
//         if(projectId == uProject.id) {
//           status = uProject.pivot.status;
//         }
//       });
      
//     return status;
//     }
//   },
  }
</script>
